function numbersOnlyString(value) {
    if (!value) {
        return;
    }

    return value.replace(/\D/g, "");
}

function yesNoFromBool(value) {
    return ((value === true || value === 'true') ? 'yes' : 'no');
}

function heightFromString(heightString) {

    if (!heightString) {
        return;
    }

    var heightSplit = heightString.replace("in", "").split("ft");

    if (heightSplit.length > 0) {

        const feet = heightSplit[0].trim();
        const inches = heightSplit[1].trim();
        const heightTotalInches = (parseInt(feet, 10) * 12) + parseInt(inches, 10);


        return {
            heightFt: feet,
            heightIn: inches,
            heightTotalIn: heightTotalInches
        }
    }
}

function calculateBMI(totalHeightInches, weight) {
  return (weight * 703) / (totalHeightInches * totalHeightInches);
}

function calculateTotalHeight(basicInfo) {
    const radix = 10;
    const heightArray = basicInfo.height.split(" ")
    const heightFeet = parseInt(heightArray[0], radix);
    let heightInches;
    for (let i = 1; i < heightArray.length; i++) {
        if (heightArray[i] !== "" && heightArray[i] !== "ft") {
            heightInches = parseInt(heightArray[i], radix);
            break;
        }
    };
    return heightFeet * 12 + heightInches;
};

export { numbersOnlyString, yesNoFromBool, heightFromString, calculateBMI, calculateTotalHeight }


// WEBPACK FOOTER //
// ./src/components/Helpers/Conversion.js